export let MAX_NUMBER_OF_TRIES: number = 8; // Default value

export const updateMaxNumberOfTries = (mode: string) => {
  MAX_NUMBER_OF_TRIES = mode === "hard" ? 5 : 8;
};

export const getMaxNumberOfTries = () => {
  return MAX_NUMBER_OF_TRIES;
};
